export default "__VITE_ASSET__ba1127xW__"